import { Box, Button, Chip, IconButton, LinearProgress, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { ControlledCustomSelect, CustomFormLabel, CustomSelectorWithLabel, ICustomSelectProps } from '../../Components/formComponents'
import { AxiosError } from 'axios'
import { axios_api } from '../../api'
import { useFormik } from 'formik'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import moment from 'moment'
import { getYearsList, groupDataByMonth, months_list } from './ReservationsV2.helpers'
import { CustomDatePicker } from '../../Components/formComponents/CustomDatePicker'
import { useOutletContext } from '../../providers'
import { defaultReservation, IReservation, IReservationTable, IReservationV2, ITableReservationRecords, ITableReservationTimeSlot, sample_reserv_data } from '../../redux/reservations'
import AddIcon from '@mui/icons-material/Add';
import { Cancel, Clear, Edit, PeopleAlt } from '@mui/icons-material'
import { UpsertReservationDialog } from '../Reservations/dialogs/UpsertReservationDialog'
import { delay } from '../../helpers/timeDelay'
import { values } from 'lodash'
import { LayoutTabsPanel } from './components/LayoutTabsPanel'
import PageContainer from '../../Components/PageContainer/PageContainer'
import { getTableWiseData } from '../../redux/reservations/reservations.helpers'
import { CustomButton } from '../../Components/CustomButton'
import { StandardCard } from '../../Components/Card'


export const CustomTableContainer = styled(TableContainer)({
    overflow: "auto",

    /* Custom scrollbar for WebKit browsers (Chrome, Safari) */
    "&::-webkit-scrollbar": {
        width: 8, /* Width of the vertical scrollbar */
        height: 8, /* Height of the horizontal scrollbar */
    },

    "&::-webkit-scrollbar-track": {
        background: "#f1f1f1", /* Background of the scrollbar track */
    },

    "&::-webkit-scrollbar-thumb": {
        background: "#888", /* Color of the scrollbar thumb */
        borderRadius: 12, /* Rounded corners of the scrollbar thumb */
    },

    "&::-webkit-scrollbar-thumb:hover": {
        background: "#555" /* Color of the scrollbar thumb on hover */
    },

    /* Custom scrollbar for Firefox */
    scrollbarWidth: "thin", /* Thin scrollbar */
    scrollbarColor: "#4e4e4e #222222", /* Thumb color, Track color */

    /* Optional: Style the scrollbar corner for WebKit browsers */
    "&::-webkit-scrollbar-corner": {
        background: "#f1f1f1" /* Background of the scrollbar corner */
    }
})


export const CustomTableCell = styled(TableCell)({
    border: "1px solid #404040",
    // background: "#222222",
    // color: "#fff",
    textAlign: "center"
});

export const ReservationsV2 = () => {
    const { outlet_details: { outlet_uuid } } = useOutletContext()

    const [reservationSlotsArray, setReservationSlotsArray] = useState<{
        time_slot: string[],
        data: ITableReservationRecords
    }>({ time_slot: [], data: {} })
    const [showInventoryError, setShowInventoryError] = useState<boolean>(false)
    const [activeTab, setActiveTab] = useState<string>("")


    const {
        values,
        errors,
        handleSubmit,
        setFieldValue,
        setValues,
        isSubmitting,
        setSubmitting
    } = useFormik({
        initialValues: {
            layout_uuid: activeTab,
            reservation_date: "",
        },
        validate: (values) => {
            const errors: any = {};
            if (!values.reservation_date) {
                errors.reservation_date = "*This field is required.";
            }
            return errors;
        },
        onSubmit: async (values) => {
            // console.log("getTableWiseData(sample_reserv_data) ==>", getTableWiseData(sample_reserv_data))
            // setReservationSlotsArray({
            //     time_slot: sample_reserv_data.map(slot => slot.time_slot),
            //     data: getTableWiseData(sample_reserv_data)
            // })
            // return
            setSubmitting(true)
            await delay(1000)
            handleOnSloteUpsert()
        },
    });

    useEffect(() => {
     if(activeTab) {
        setValues({
            layout_uuid: activeTab,
            reservation_date: ''
        })
        setReservationSlotsArray({
            time_slot: [],
            data: {}
        })
     }
    }, [activeTab])
    
    console.log("activeTab ===> ", activeTab)


    const handleOnSloteUpsert = () => {
        setSubmitting(true)
        axios_api.get(`/reservation/check-slots-details`, {
            params: {
                layout_uuid: values.layout_uuid || activeTab,
                outlet_uuid,
                date: values.reservation_date
            }
        }).then((res) => {
            const reservatios: ITableReservationTimeSlot[] = res.data.data
            setShowInventoryError(false)
            setReservationSlotsArray(res.data.data)
            setReservationSlotsArray({
                time_slot: reservatios.map(slot => slot.time_slot),
                data: getTableWiseData(reservatios)
            })
        }).catch((error: AxiosError) => {
            setReservationSlotsArray({
                time_slot: [],
                data: {}
            })
            console.error(" setShowInventoryError ", error)
            if (error?.response?.status === 404) {
                console.error(" setShowInventoryError IN  ", error.status)
                setShowInventoryError(true)
            }
        }).finally(() => {
            setSubmitting(false)
        })
    }

    const mergeColumns = (records: { time_slot: string; status: string; reservation_details: IReservationV2[] }[]) => {
        let mergedData: { time_slot: string; status: string; reservation_details: IReservationV2[]; colSpan: number }[] = [];
        let i = 0;
        while (i < records.length) {
            let colSpan = 1;
            while (
                i + colSpan < records.length &&
                records[i].reservation_details.length > 0 &&
                records[i + colSpan].reservation_details.length > 0 &&
                records[i].reservation_details[0].reservation_uuid === records[i + colSpan].reservation_details[0].reservation_uuid
            ) {
                colSpan++;
            }
            mergedData.push({ ...records[i], colSpan });
            i += colSpan;
        }
        return mergedData;
    };

    return (
        <PageContainer title='Reservations' description='Reservations'>
            <Typography variant="h2">Reservations</Typography>
            <LayoutTabsPanel
                selectedDate={values.reservation_date}
                activeTab={activeTab}
                onTabChange={(tab) => setActiveTab(tab)}
                onInsertSuccess={handleOnSloteUpsert} />

            <Box sx={{ minHeight: "calc(100vh - 6.66vh)", mt: 1 }}>
                <StandardCard sx={{ display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1,
                        }}>
                <CustomFormLabel variant='h3'>
                        Select Date to check to slot availability
                    </CustomFormLabel>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "flex-start",
                            gap: 2,
                        }}
                        component="form" onSubmit={handleSubmit} >
                        <CustomDatePicker
                            fieldName="reservation_date"
                            value={values.reservation_date}
                            onChange={(newValue, formattedDate) => {
                                setFieldValue("reservation_date", formattedDate);
                            }}
                            error={errors.reservation_date}
                        />
                        <CustomButton variant='outlined' type='submit' sx={{ background: "secondary" }}  >Search</CustomButton>
                    </Box>
                </StandardCard>
                {/* <Box
                    p={2}
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1,
                        background: "#1e1e1e"
                    }}>
                  
                </Box > */}

                {isSubmitting ?
                    (
                        <LinearProgress sx={{ color: "#fff" }} />

                    ) : showInventoryError ? (
                        <Box sx={{ py: 4, display: "flex", justifyContent: "center", alignItems: "center", gap: 0.5 }}>
                            <Typography variant="h6" sx={{ color: "#fff" }}>No Record found!</Typography>
                        </Box>
                    ) : Object.keys(reservationSlotsArray.data).length > 0 ?
                        <Box sx={{ pt: 3 }}>

                            <CustomTableContainer  >
                                <Table size="small" aria-label="a dense table">
                                    <TableHead>
                                        <TableCell />
                                        {reservationSlotsArray.time_slot.map((time, th_index) => (
                                            <TableCell sx={{ fontWeight: 700, fontSize: 12, textAlign: 'center', minWidth: 80 }} key={th_index}>{time.split(" ")[0]}</TableCell>
                                        ))}
                                        {/* {reservationSlotsArray.slice(0, 1).map((timeSlot, s_index) => (
                                            <TableRow>
                                                <CustomTableCell sx={{ fontWeight: 700, fontSize: 12 }} key={s_index}>Time Slot</CustomTableCell>
                                                {
                                                    timeSlot.tables.map((table, t_index) => (
                                                        <CustomTableCell sx={{ fontWeight: 700, fontSize: 12 }} key={t_index}>{`Table No. ${table.table_number}`}</CustomTableCell>
                                                    ))
                                                }
                                            </TableRow>
                                        ))} */}
                                    </TableHead>
                                    <TableBody>
                                        {Object.entries(reservationSlotsArray.data).map(([tableNumber, reservations]) => {
                                            return (
                                                <TableRow key={tableNumber}>
                                                    <CustomTableCell sx={{ height: 80 }}>{tableNumber}</CustomTableCell>
                                                    {mergeColumns(reservations).map((resrv, r_index) => (
                                                        <CustomTableCell
                                                            key={resrv.time_slot}
                                                            colSpan={resrv.colSpan}
                                                        >
                                                           <TebleReservationCellV2 data={resrv} />
                                                        </CustomTableCell>
                                                    ))}
                                                    {/* {reservations.map((resrv, r_index) => (
                                                        <CustomTableCell key={r_index}>
                                                            <TebleReservationCellV2 data={resrv} />
                                                        </CustomTableCell>
                                                    ))} */}
                                                </TableRow>
                                            )
                                        })}


                                        {/* {reservationSlotsArray.map((timeSlot, s_index) => (
                                            <TableRow>
                                                <CustomTableCell key={`${s_index}-${timeSlot.time_slot}`}>{timeSlot.time_slot.split(" ")[0]}</CustomTableCell>
                                                {
                                                    timeSlot.tables.map((table, t_index) => (
                                                        <TebleReservationCell
                                                            key={`${t_index}-${table.table_id}`}
                                                            keyIndex={s_index}
                                                            subKeyindex={t_index}
                                                            table={table}
                                                            reservation_date={values.reservation_date}
                                                            onSuccess={handleOnSloteUpsert}
                                                        />
                                                    ))
                                                }
                                            </TableRow>
                                        ))} */}
                                    </TableBody>
                                </Table>
                            </CustomTableContainer>
                        </Box >
                        :
                        <></>
                }
            </Box >
        </PageContainer>
    )
}

export const TebleReservationCellV2: React.FC<{
    data: { time_slot: string, status: string, reservation_details: IReservationV2[] },
}> = ({
    data
}) => {
        const { outlet_details: { outlet_uuid } } = useOutletContext()
        const [openUpsertDialog, setOpenUpsertDialog] = useState<IReservation | null>(null)

        if (data.status === "RESERVED") {
            const reservedData = data.reservation_details[0]
            if (!reservedData) return <></>
            console.log('reservedData ==>', reservedData)
            return (
                <Box sx={{
                    "&:hover .hover-content": { opacity: 1 }, // Show content on hover
                    height: '100%', width: '100%', display: 'flex', alignItems: 'flex-start', padding: 1,
                    background: "#0fb837bf", borderRadius: 1, position: "relative", minHeight: 80, minWidth: 80
                }}>
                    <Typography variant='h3'>{reservedData.user_name}</Typography>
                    {/* <Box className="hover-content"
                    sx={{
                        opacity: 1, transition: "opacity 0.3s ease", mt: 1, position: "absolute",
                        display: "flex", justifyContent: "flex-end", top: 0, right: 0
                    }}
                >
                    <IconButton color='primary'><Edit /></IconButton>
                    <IconButton color='error'><Clear /></IconButton>
                </Box> */}

                    <Box
                        sx={{
                            transition: "opacity 0.3s ease", mt: 1, position: "absolute",
                            display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 0.5, bottom: 2, left: 5,
                        }}
                    >
                        <PeopleAlt /><Typography variant='h3'>{`${reservedData.number_of_people} ${reservedData.from_time}-${reservedData.to_time}`}</Typography>
                    </Box>
                </Box>
            )
        }
        return (
            <Box sx={{
                "&:hover .hover-content": { opacity: 1 }, // Show content on hover
                height: '100%', width: '100%', display: 'flex', alignItems: 'center',
                borderRadius: 1, position: "relative", minHeight: 80, minWidth: 80
            }}>
            </Box>
        )
    }


export const TebleReservationCell: React.FC<{
    keyIndex: number, reservation_date: string,
    subKeyindex: number, table: IReservationTable,
    onSuccess: () => void
}> = ({
    keyIndex, reservation_date, subKeyindex, table, onSuccess
}) => {
        const { outlet_details: { outlet_uuid } } = useOutletContext()
        const [openUpsertDialog, setOpenUpsertDialog] = useState<IReservation | null>(null)

        return (
            <CustomTableCell sx={{
                "&:hover .hover-content": { opacity: 1 }, // Show content on hover
            }}>
                <ReservationStatus status={table.status} />
                <Box className="hover-content"
                    sx={{ opacity: 0, transition: "opacity 0.3s ease", mt: 1 }}
                >
                    {table.status === "AVAILABLE" ? <Button

                        variant='contained'
                        fullWidth
                        onClick={() => setOpenUpsertDialog({
                            ...defaultReservation,
                            reservation_date,
                            outlet_uuid: outlet_uuid || "",
                            table_id: table.table_id,
                            table_no: table.table_number,

                        })}

                    ><AddIcon />Add</Button>
                        :
                        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
                            <Button variant='contained' color='primary' fullWidth><Edit /></Button>
                            <Button variant='outlined' color='error' fullWidth><Clear /></Button>
                        </Box>
                    }
                </Box>
                {openUpsertDialog && <UpsertReservationDialog open={true}
                    reservation={openUpsertDialog}
                    disableTableInfo
                    onClose={() => setOpenUpsertDialog(null)}
                    onSuccess={onSuccess}
                />}
            </CustomTableCell>
        )
    }

export const ReservationStatus: React.FC<{ status: string }> = ({ status }) => {
    const currentStatus = status.toUpperCase()
    return (
        <Box sx={{
            wordBreak: "normal",
            // width: `${Math.max(status.length * 8)}px`,
            background: currentStatus === "AVAILABLE" ? "#1dda28ab" : "#ff4100bd",
            px: 1,
            pt: 0.5,
            pb: 0.625,
            borderRadius: 1,
            textAlign: 'center',
            fontWeight: 700,
            whiteSpace: "nowrap",
            cursor: "pointer"
        }}>
            {currentStatus}
        </Box>
    )
}